import { styled, Typography } from "@mui/material";

export const ReferenceBookBlockTitle = styled(Typography)(({ theme }) => ({
  ...theme.typography.h2,
  color: theme.palette.custom.grey.accentText,
  mb: "0.5rem",
}));
